var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/naming-convention */
import { END_STATE, PAUSE_TYPE, PLAY_EVENT, PLAY_MODE, VIDEO_NODE_EVENT, VIDEO_STATE, } from '../enums';
import { AUDIO_TRACK_ERROR_MSG, } from '../interfaces';
import { OrgIOSVideoNode } from '../kernel-origin/org-ios-videonode';
import OrgVideoNode from '../kernel-origin/org-videonode';
import { detectStream } from '../libs/detect-stream';
import EvtEmitter from '../libs/event-emitter';
import { jsonTool, Logger, logMethodCallDecoratorCreator, uaTool, videoTool } from '../util';
import CheckPlayerStatus from './check-player-status';
import { checkUrlConfigVailed, compareUrlConfig, IGNORE_EVT_TYPE, IGNORE_VIDEO_EVT, videoEvt2PlayerEvtMap, } from './play-helper';
import ScreenWakeLock from './screen-wakelock';
import VideoInfo from './video-info';
var logMethodCall = logMethodCallDecoratorCreator('BasePlayer');
var BasePlayer = /** @class */ (function (_super) {
    __extends(BasePlayer, _super);
    function BasePlayer(opts) {
        var _a;
        var _this = _super.call(this) || this;
        _this._firstPlaying = false;
        /** 是否具有用户手势（跟自动播放相关的一个名词，具体google。这个变量在视频首帧起播以后变为true，只有destroy以后会重置） */
        _this._hasUserGestures = false;
        _this._volume = 1;
        _this._playbackRate = 1;
        /** 播放被阻止的状态中 */
        _this._playBlocking = false;
        /** 最后一次播放的video info，允许在播放器stop后外部依然可以访问currentVideoInfo */
        _this.lastVideoInfo = null;
        _this._logger = new Logger(opts.instanceId, 'BasePlayer');
        _this._config = opts;
        _this._videoInfos = []; // 地址列表
        _this._curUrlIdx = -1; // 当前的播放地址索引
        _this._curVideoNode = null;
        _this._preloaders = [];
        _this._vnList = [];
        _this._eventMap = {
            videonode: _this.videonodeEventHandler.bind(_this),
            document: _this.visibilityChangeHandler.bind(_this),
        };
        _this._played = false;
        _this.videoEvtHandlerMap = (_a = {},
            _a[VIDEO_NODE_EVENT.STATE_CHANGE] = _this.onVideoNodeStateChange.bind(_this),
            _a[VIDEO_NODE_EVENT.PLAY_PROMISE_CATCHED] = _this.onVideoNodePlayPromiseCatched.bind(_this),
            _a[VIDEO_NODE_EVENT.FIRST_PLAYING] = _this.onVideoNodeFirstPlaying.bind(_this),
            _a[VIDEO_NODE_EVENT.PLAY_OVER] = _this.onVideoNodePlayOver.bind(_this),
            _a[VIDEO_NODE_EVENT.ERROR] = _this.onVideoNodeError.bind(_this),
            _a);
        _this.screenWakeLock = new ScreenWakeLock();
        _this.playerStatusChecker = new CheckPlayerStatus(_this);
        document.addEventListener('visibilitychange', _this._eventMap.document);
        if (!_this._config.createVideoNodeWhenLoad) {
            _this.createVideoNodes(_this._config.maxVideoNodeCount);
        }
        return _this;
    }
    BasePlayer.prototype.load = function (value, extra) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!value || (value instanceof Array && value.length <= 0)) {
                    this.clearBeforeLoad();
                    return [2 /*return*/];
                }
                this.loadInner(value, extra);
                return [2 /*return*/];
            });
        });
    };
    BasePlayer.prototype.play = function (value, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state === VIDEO_STATE.IDLE && !value) {
                            // idle状态，没有参数时候直接return
                            this._logger.warn('play(), no urlConfig when idle state');
                            return [2 /*return*/];
                        }
                        this._checkPlayBlocked = true;
                        if (!(this._vnList.length <= 1 || this._hasUserGestures)) return [3 /*break*/, 1];
                        this._logger.log('play(), skip triggerAutoplay().');
                        this.triggerPlayResolve(value, extra);
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.triggerAutoplay()];
                    case 2:
                        _a.sent();
                        this.triggerPlayResolve(value, extra);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        // 如果在点播模式下，调用play接口的时候自动播放被阻止，那就默认给调用一下load方法，此时应用方只需要在点击事件中空调用一下play接口
                        if (this._config.type === PLAY_MODE.VOD && value) {
                            this.loadInner(value, extra);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BasePlayer.prototype.triggerAutoplay = function () {
        var _this = this;
        if (this._triggerAutoplayPromise) {
            return this._triggerAutoplayPromise;
        }
        this._logger.log('triggerAutoplay(), start');
        var allPromise = [];
        var len = this._vnList.length;
        for (var i = 0; i < len; i++) {
            var videoNodePromise = this._vnList[i].triggerAutoplay();
            allPromise.push(videoNodePromise);
        }
        this._triggerAutoplayPromise = Promise.all(allPromise);
        this._triggerAutoplayPromise.catch(function (e) {
            _this._logger.log('play() triggerAutoplay catched: ', e);
            _this.playBlocked();
        });
        return this._triggerAutoplayPromise;
    };
    BasePlayer.prototype.seek = function (time) {
        var _a;
        if (this.state === VIDEO_STATE.IDLE) {
            // 播放idle状态，即使seek回去，也没法调用play()继续播放了。这里就直接return掉了。想播放结束了seek回去播，那不如重新播放并指定位置？
            return false;
        }
        if (time < 0 || !((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)) {
            return false;
        }
        // 通过接口调用的seek都应该视为用户行为
        return this._curVideoNode.seek(time, true);
    };
    BasePlayer.prototype.pause = function (pauseType) {
        if (!this._played) {
            this._logger.warn('pause(), player has not been played');
            return;
        }
        this.pauseInner(pauseType || PAUSE_TYPE.USER);
    };
    BasePlayer.prototype.stop = function (endState) {
        if (endState === void 0) { endState = END_STATE.INTERRUPT; }
        if (this.state === VIDEO_STATE.IDLE) {
            return;
        }
        this.stopInner(endState, true);
    };
    BasePlayer.prototype.setLevel = function (urlOrUrlConfig, backupUrls, extraConfig) {
        var url;
        if (typeof urlOrUrlConfig === 'string') {
            url = urlOrUrlConfig;
        }
        else {
            url = urlOrUrlConfig.url;
            backupUrls = urlOrUrlConfig.backupUrls;
            extraConfig = urlOrUrlConfig;
        }
        var errMag = this.playerStatusChecker.checkSetLevelError(url);
        if (errMag) {
            this._logger.warn("setLevel(), ".concat(errMag));
            return Promise.reject(new Error(errMag));
        }
        this._urlBeforeSetLevel = { url: url, backupUrls: backupUrls };
        this.currentVideoInfo.config.url = url;
        if (backupUrls) {
            this.currentVideoInfo.config.backupUrls = backupUrls;
        }
        if (extraConfig) {
            Object.assign(this._urlBeforeSetLevel, extraConfig);
            Object.assign(this.currentVideoInfo.config, extraConfig);
        }
        this.currentVideoInfo.reset();
        return this.setLevelInner(this.currentVideoInfo.config);
    };
    BasePlayer.prototype.appendNext = function (urlConfig) {
        // 预检查是否当前播放环境是否支持append
        var appendDetail = this.playerStatusChecker.checkCanAppend(urlConfig);
        if (!appendDetail.canAppend) {
            this._logger.warn(appendDetail.message);
            return false;
        }
        // 播放列表中已经存在该视频配置
        var existVideoInfo = this._videoInfos.find(function (e) { return compareUrlConfig(e.config, urlConfig); });
        if (existVideoInfo) {
            this._logger.warn("appendNext(), duplicate append! uid[".concat(existVideoInfo.uid, "]"));
            return false;
        }
        // 判断预加载列表中是否有一样的url地址，没有则创建新的IVideoInfo
        var appendVideoInfo = this.preloadVideoInfos.find(function (e) { return compareUrlConfig(e.config, urlConfig); });
        if (!appendVideoInfo) {
            appendVideoInfo = new VideoInfo(urlConfig, this._config);
        }
        // 除了即将添加的播放数据保留，其他的预加载全部清理掉
        this.clearAllPreloadInner(appendVideoInfo);
        // 覆盖式添加到当前播放地址的下一个
        this._videoInfos = this._videoInfos.slice(0, this._curUrlIdx + 1);
        this._videoInfos = this._videoInfos.concat(appendVideoInfo);
        this._logger.log('appendNext() succ, appendVideoInfo=', appendVideoInfo);
        this.emit(PLAY_EVENT.LIST_CHANGE);
        // append以后可能需要判断是否马上播放下一个等操作
        this.appendAfter(appendVideoInfo);
        return true;
    };
    BasePlayer.prototype.preloadNext = function () {
        var _this = this;
        var confs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            confs[_i] = arguments[_i];
        }
        // 预检查是否当前播放环境是否支持preload
        var preloadDetail = this.playerStatusChecker.checkCanPreloadEnvi(confs);
        if (!preloadDetail.canPreload) {
            this._logger.warn(preloadDetail.message);
            return false;
        }
        var preloadVideoInfos = [];
        confs.forEach(function (conf) {
            var preloadEachUrlDetail = _this.playerStatusChecker.checkCanPreloadEachConfig(conf);
            if (!preloadEachUrlDetail.canPreload) {
                _this._logger.warn(preloadEachUrlDetail.message);
                return;
            }
            if (_this.nextVideoInfo && compareUrlConfig(conf, _this.nextVideoInfo.config)) {
                // 预加载的地址中已经有播放列表中的下一个（可能先appendNext到播放列表中了，稍后才调用preloadNext接口预加载）
                preloadVideoInfos.push(_this.nextVideoInfo);
            }
            else {
                // 否则创建一个新的视频信息，开始预加载
                preloadVideoInfos.push(new VideoInfo(conf, _this._config));
            }
        });
        this.preloadInner.apply(this, __spreadArray([false, { startTime: 0, kernelName: this.kernelName }], preloadVideoInfos, false));
        return true;
    };
    BasePlayer.prototype.clearAllPreload = function () {
        this.clearAllPreloadInner();
    };
    BasePlayer.prototype.playNext = function (opts) {
        if (!this._played) {
            this._logger.warn('playNext(), player has not been played');
            return;
        }
        this.playNextInner({ isInterrupt: true });
    };
    BasePlayer.prototype.hasAppended = function (value) {
        return !!this._videoInfos.find(function (e) { return compareUrlConfig(e.config, value); });
    };
    BasePlayer.prototype.hasPreloaded = function (value) {
        return !!this.preloadVideoInfos.find(function (e) { return compareUrlConfig(e.config, value); });
    };
    BasePlayer.prototype.setAudioTrack = function (id) {
        return Promise.reject(AUDIO_TRACK_ERROR_MSG.NOT_SUPPORT);
    };
    BasePlayer.prototype.getAudioTrackList = function () {
        if (!this.currentVideoInfo)
            return [];
        return this.currentVideoInfo.audioTracks;
    };
    BasePlayer.prototype.getCurrentAudioTrack = function () {
        if (!this.currentVideoInfo)
            return NaN;
        return this.currentVideoInfo.currentAudioTrack;
    };
    BasePlayer.prototype.resizeVideoElements = function (value) {
        var videoElements = this.videoElements;
        if (!value || !videoElements || videoElements.length <= 0) {
            return;
        }
        videoElements.forEach(function (videoElement) {
            videoTool.resizeElement(videoElement, value);
        });
        this.emit(PLAY_EVENT.RESIZE, value);
    };
    BasePlayer.prototype.resize = function (value) {
        this.resizeVideoElements(value);
    };
    BasePlayer.prototype.captureVideo = function (dx, dy, dw, dh, extra) {
        var _a;
        var video = this.currentVideoElement;
        if (!video)
            return;
        if (video instanceof HTMLVideoElement) {
            try {
                var data = videoTool.captureVideo(video, { dx: dx, dy: dy, dw: dw, dh: dh });
                return Promise.resolve(data);
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
        return (_a = video.captureVideo) === null || _a === void 0 ? void 0 : _a.call(video, dx, dy, dw, dh);
    };
    BasePlayer.prototype.destroy = function () {
        var _a, _b;
        this.stopInner();
        if (this._vnList) {
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].destroy();
            }
        }
        if (this._preloaders) {
            this._preloaders.forEach(function (preloader) {
                preloader.clear();
            });
            this._preloaders = null;
        }
        document.removeEventListener('visibilitychange', this._eventMap.document);
        this.removeAllListeners();
        // 释放屏幕常亮
        (_a = this.screenWakeLock) === null || _a === void 0 ? void 0 : _a.keepAlive(false);
        this.screenWakeLock = null;
        this._videoInfos = null;
        this._curVideoNode = null;
        this._vnList = null;
        this._eventMap = null;
        this.lastVideoInfo = null;
        (_b = this.playerStatusChecker) === null || _b === void 0 ? void 0 : _b.destroy();
        this.playerStatusChecker = null;
    };
    Object.defineProperty(BasePlayer.prototype, "duration", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.duration : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "playtime", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.playtime : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "state", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.state : VIDEO_STATE.IDLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "played", {
        get: function () {
            return this._played;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "playbackRate", {
        get: function () {
            return this._playbackRate;
        },
        set: function (value) {
            this._playbackRate = value;
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].playbackRate = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "supportPlaybackRate", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "supportPreload", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            this._volume = value;
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].volume = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "useWorker", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.useWorker : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoElements", {
        get: function () {
            var _a;
            return (_a = this._vnList) === null || _a === void 0 ? void 0 : _a.map(function (vn) { return vn.videoElement; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoElement", {
        /** 获取当前videonode的video元素 */
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoElement : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoInfos", {
        get: function () {
            return this._videoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "preloadVideoInfos", {
        get: function () {
            return this._preloaders.map(function (preloader) { return preloader.videoInfo; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoSize", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoSize : { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoBuffered", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoBuffered : [{ start: 0, end: 0 }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoInfo", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.currentVideoInfo : this.lastVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "nextVideoInfo", {
        /** 列表播放的下一个视频信息，如果超限返回undefined */
        get: function () {
            return this._videoInfos[this._curUrlIdx + 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoInfoIdx", {
        get: function () {
            return this._curVideoNode ? this._videoInfos.indexOf(this._curVideoNode.currentVideoInfo) : -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "totalVideoInfoCount", {
        get: function () {
            return this._videoInfos.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "config", {
        /** 获取当前内核的配置信息 */
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "curUrlIdx", {
        /** 获取当前Url序号 */
        get: function () {
            return this._curUrlIdx;
        },
        enumerable: false,
        configurable: true
    });
    BasePlayer.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log.apply(_a, args);
    };
    /** 加载视频player内部实现方法，用于各个内核继承和内部调用 */
    BasePlayer.prototype.loadInner = function (value, extra) {
        var _this = this;
        // 调用播放器load方法，就一定会先停止先前的播放
        this.clearBeforeLoad();
        var checkUrlConfigError = checkUrlConfigVailed(value, this.kernelName);
        if (checkUrlConfigError) {
            this.emit(PLAY_EVENT.ERROR, { videoInfo: { error: checkUrlConfigError } });
            return false;
        }
        if (this._config.createVideoNodeWhenLoad) {
            this._vnList.forEach(function (videoNode) { return videoNode.destroy(); });
            this._vnList.length = 0;
            this.createVideoNodes(this._config.maxVideoNodeCount);
        }
        // 相当于重新开始播放，通知外部重新播放事件
        this.emit(PLAY_EVENT.RESTART);
        var _a = (extra || {}).startTime, startTime = _a === void 0 ? 0 : _a;
        this._videoInfos = [].concat(value).map(function (conf) { return new VideoInfo(conf, _this._config); });
        this.emit(PLAY_EVENT.LIST_CHANGE);
        // 第一个视频不管是否支持预加载，都可以调用load接口
        var firstVideoInfo = this._videoInfos[0];
        this.preloadInner(true, __assign(__assign({}, extra), { startTime: startTime, kernelName: this.kernelName }), firstVideoInfo);
        return true;
    };
    /** 暂停播放player内部实现方法，用于各个内核继承和内部调用 */
    BasePlayer.prototype.pauseInner = function (type) {
        if (type === void 0) { type = PAUSE_TYPE.INNER; }
        if (this.state === VIDEO_STATE.PAUSE) {
            return;
        }
        if (this._curVideoNode) {
            this._curVideoNode.pause(type);
        }
    };
    BasePlayer.prototype.resumeInner = function () {
        var _a;
        if (!this._played) {
            return;
        }
        // duration为0的情况可能是video设置了src并且调用了播放，但是被阻止播放，此时duration是0
        // playtime < duration是限制只能在视频未结束调用（在视频结束调用play可能会从头开始播放）
        if (((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)
            && (this._curVideoNode.duration === 0 || this._curVideoNode.playtime < this._curVideoNode.duration)) {
            this._curVideoNode.videoplay();
        }
    };
    BasePlayer.prototype.stopInner = function (endState, dispatchEvt, videoInfo) {
        var _a;
        if (endState === void 0) { endState = END_STATE.NORMAL; }
        if (dispatchEvt === void 0) { dispatchEvt = false; }
        if (videoInfo === void 0) { videoInfo = null; }
        // 要先清掉预加载，否则下面stop每个videonode的时候可能还会收到videonode的事件，例如end事件，然后这个end事件
        // 会触发尝试播放下一个视频，此时如果预加载信息还在，可能会使用未清除的预加载继续播放。
        if (((_a = this._config) === null || _a === void 0 ? void 0 : _a.type) === PLAY_MODE.VOD) {
            this.clearAllPreloadInner();
        }
        // 存一下videoInfos数组，马上置空this._videoInfos。这里为了避免在列表播放时，当前videoNode播放时外部停止了播放，
        // 当前videoNode会发出end，idle事件，然后checkPlayNext里面尝试播放下一个videoNode。这不符合外部停止播放的预期。
        // 因此先置空videoInfos，此时this.nextVideoInfo为空，就不会继续尝试播放下一个videoNode了
        var videoInfos = this._videoInfos;
        this._videoInfos = [];
        // 缓存一下last video info
        this.lastVideoInfo = this.currentVideoInfo;
        if (this._vnList) {
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                // 先销毁videonode再移除videonode上的事件，便于销毁时仍能监听到videonode发出的idle等事件
                this._vnList[i].stop();
                this.setPlayEvents(this._vnList[i], false);
            }
        }
        this._curUrlIdx = -1;
        if (videoInfos) {
            videoInfos.forEach(function (vi) {
                vi.destroy();
            });
        }
        this._firstPlaying = false;
        this._played = false;
        this._curVideoNode = null;
        var error = videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error;
        var endStateValue = error ? END_STATE.ERROR : endState;
        this._logger.log("stopInner(), endState=".concat(endStateValue));
        // 派发stop和error事件
        if (!dispatchEvt) {
            return;
        }
        this.emit(PLAY_EVENT.STOPED, {
            videoInfo: videoInfo,
            isUserStop: endState === END_STATE.INTERRUPT,
            endState: endStateValue,
        });
        if (error) {
            this.emit(PLAY_EVENT.ERROR, { videoInfo: videoInfo });
        }
    };
    BasePlayer.prototype.preloadInner = function (isFirstLoad, extra) {
        var preloadVideoInfos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            preloadVideoInfos[_i - 2] = arguments[_i];
        }
        var preloaders = [];
        var len = preloadVideoInfos.length;
        if (len <= 0) {
            return;
        }
        for (var i = 0; i < len; i++) {
            if (!preloadVideoInfos[i]) {
                continue;
            }
            this.clearPreloader(preloadVideoInfos[i]);
            var preloader = this.preparePreloader(isFirstLoad, preloadVideoInfos[i]);
            if (preloader) {
                // 设置预加载的依赖
                preloadVideoInfos[i].setDependVideoInfo(this.currentVideoInfo);
                preloader.load(isFirstLoad, this, preloadVideoInfos[i], extra);
                preloaders.push(preloader);
            }
        }
        this._preloaders = this._preloaders.concat(preloaders);
        this._logger.log('preload(), preloader\'s length: ', this._preloaders.length);
        // 最后才发出事件，避免外部监听预加载开始事件以后马上操作预加载列表。
        if (preloaders.length > 0) {
            this.emit(PLAY_EVENT.PRELOAD_START, { preloadVideoInfos: preloaders.map(function (preloader) { return preloader.videoInfo; }) });
        }
    };
    BasePlayer.prototype.playNextInner = function (opts) {
        var isInterrupt = (opts || {}).isInterrupt;
        this._logger.log("playNextInner(), curUrlIdx=".concat(this._curUrlIdx, "/")
            + "urlLength=".concat(this._videoInfos.length, "/isInterrupt=").concat(isInterrupt));
        var isMinTime = Math.abs(this.playtime - this.duration) <= this._config.interruptPlayNextMinTime;
        if (isInterrupt && isMinTime && this.state === VIDEO_STATE.PLAYING) {
            // 时间太短，马上会跳段了而不需要打断，所以这里加了一个判断
            this._logger.log('playNextInner(), playNext right now! return!');
            return;
        }
        if (this._curUrlIdx + 1 >= this._videoInfos.length) {
            this._logger.warn('There is no next VideoInfo.');
            return;
        }
        this._curUrlIdx += 1;
        this.setPlayEvents(this._curVideoNode, false);
        // 打断式切换要先停止当前的播放
        if (isInterrupt) {
            this._curVideoNode.pause(PAUSE_TYPE.INNER);
        }
        // 这个时候this._videoInfos[this._curUrlIdx]的值和this.currentVideoNode是不一样的。
        var videoInfo = this._videoInfos[this._curUrlIdx];
        // 除了即将播放的视频数据保留，其他的全部清理掉
        this.clearAllPreloadInner(videoInfo);
        if (isInterrupt) {
            // 如果是打断式切换，派发当前段播放结束。事件结束后再开始播下一个
            this.emit(PLAY_EVENT.VIDEONODE_PLAY_OVER, { videoInfo: this.currentVideoInfo });
        }
        this.playInner();
    };
    /**
    * 清理所有预加载内部调用
    * @param exceptVideoInfo 保留的预加载视频
    */
    BasePlayer.prototype.clearAllPreloadInner = function (exceptVideoInfo) {
        var _this = this;
        if (!this._preloaders || this._preloaders.length <= 0) {
            return;
        }
        var removePreloaders = this._preloaders.filter(function (preloader) { return preloader.videoInfo !== exceptVideoInfo; });
        // 一个一个清理预加载列表中的视频数据
        removePreloaders.forEach(function (removePreloader) {
            _this.clearPreloader(removePreloader.videoInfo);
        });
    };
    /** 在视频加载前清理 */
    BasePlayer.prototype.clearBeforeLoad = function () {
        var _a;
        // 在重新load时清理所有video标签（当配置项clearVideoAfterStop为false时，在stop时可能并未清理video标签）
        (_a = this._vnList) === null || _a === void 0 ? void 0 : _a.forEach(function (videoNode) {
            videoTool.clear(videoNode.videoElement);
        });
        this.stopInner(this._played ? END_STATE.INTERRUPT : END_STATE.NORMAL, this._played, // 如果当前正在播放，还需要派发stop事件出去
        this._played ? this.currentVideoInfo : null);
    };
    /** 内部实现的清理单个视频的预加载, 会从预加载的数组删除预加载地址 */
    BasePlayer.prototype.clearPreloader = function (videoInfo, keepLoadedData) {
        if (!this._preloaders || this._preloaders.length <= 0) {
            return;
        }
        if (!videoInfo) {
            return;
        }
        var idx = this.findPreloadIdxByVideoInfo(videoInfo);
        if (idx === -1) {
            // 根本没有预加载过
            return;
        }
        var preloader = this._preloaders.splice(idx, 1)[0];
        preloader.clear(keepLoadedData);
    };
    /** 查找预加载VideoInfo序号 */
    BasePlayer.prototype.findPreloadIdxByVideoInfo = function (videoInfo) {
        if (!videoInfo) {
            return -1;
        }
        return this._preloaders.findIndex(function (preloader) { return preloader.videoInfo === videoInfo; });
    };
    /** 选择清晰度的切换模式，各个内核可以选择复写 */
    BasePlayer.prototype.decideSetLevelMode = function (forceSetLevelMode) {
        return this.playerStatusChecker.checkSetLevelMode(this._vnList.length, forceSetLevelMode);
    };
    /** 创建单个的VideoNode */
    BasePlayer.prototype.createVideoNode = function (conf) {
        return uaTool.os.ios ? new OrgIOSVideoNode(conf) : new OrgVideoNode(conf);
    };
    /**  创建VideoNode列表，每种内核的列表长度可能不一样。 */
    BasePlayer.prototype.createVideoNodes = function (count) {
        for (var i = 0; i < count; i++) {
            var vn = this.createVideoNode(this._config);
            vn.idx = i;
            // 如果有createVideoNodeWhenLoad配置项，VideoNode是在load接口中创建的，因此还需要再次赋值一次volume避免音量丢失
            vn.volume = this._volume;
            vn.playbackRate = this._playbackRate;
            if (vn.videoElement instanceof HTMLElement) {
                vn.videoElement.dataset.idx = "".concat(i);
            }
            this._vnList.push(vn);
        }
    };
    /** 给videoNode添加或者移除播放监听 */
    BasePlayer.prototype.setPlayEvents = function (vn, isSet) {
        var _this = this;
        if (!vn) {
            return;
        }
        if (isSet) { // 先移除，保证只有一次添加
            this.setPlayEvents(vn, false);
        }
        this._logger.log("set VideoNode evts, idx=".concat(vn.idx, "/isSet=").concat(isSet));
        Object.keys(VIDEO_NODE_EVENT).forEach(function (k) {
            var evtHandler = isSet ? vn.on : vn.off;
            evtHandler.apply(vn, [VIDEO_NODE_EVENT[k], _this._eventMap.videonode]);
        });
    };
    /** videoNode事件监听回调 */
    BasePlayer.prototype.videonodeEventHandler = function (e) {
        this.logVideoNodeEvts(e);
        // 是否需要将videoNode的事件转发为player的事件。默认需要转发。但执行每个对应事件回调时也会返回是否需要转发。
        var shouldDispatchPlayEvt = true;
        // 对videoNode发出的事件的内部处理
        if (this.videoEvtHandlerMap[e.type]) {
            shouldDispatchPlayEvt = this.videoEvtHandlerMap[e.type](e);
        }
        // 如果有对应的player事件，转发videonode事件
        if (shouldDispatchPlayEvt && (e.type in videoEvt2PlayerEvtMap)) {
            this.emit(videoEvt2PlayerEvtMap[e.type], e.data);
        }
    };
    /** 处理videoNode播放状态变化 */
    BasePlayer.prototype.onVideoNodeStateChange = function (e) {
        if (e.data.new === VIDEO_STATE.PAUSE && e.data.pauseType === PAUSE_TYPE.INNER) {
            this._logger.log('inner pause does not emit event.');
            return false;
        }
        if (e.data.new === VIDEO_STATE.PLAYING) {
            this._checkPlayBlocked = false;
        }
        // 播放状态变为Playing时，设置屏幕常亮
        this.screenWakeLock.keepAlive(e.data.new === VIDEO_STATE.PLAYING);
        return true;
    };
    /** 处理videoNode起播Promise捕获 */
    BasePlayer.prototype.onVideoNodePlayPromiseCatched = function (e) {
        if (this._checkPlayBlocked && e.data.isAutoPlayBlocked) {
            this._checkPlayBlocked = false;
            this.playBlocked();
        }
        return true;
    };
    /** 处理videoNode首次起播 */
    BasePlayer.prototype.onVideoNodeFirstPlaying = function (e) {
        if (!this._firstPlaying) {
            // FIRST_PLAYING无论有多少个videonode，都只对外转发一次
            this.emit(PLAY_EVENT.FIRST_PLAYING, { videoInfo: this.currentVideoInfo });
            this._firstPlaying = true;
            this._hasUserGestures = true;
        }
        return true;
    };
    /** 处理videoNode播放结束，检查下一个播放 */
    BasePlayer.prototype.onVideoNodePlayOver = function (e) {
        if (!this._config.isPlayList && !this.nextVideoInfo) {
            var videoInfo = this.currentVideoInfo;
            // videonode里面正常结束，需要在player这一层调用stopInner重置一些变量，但如果是两个场景不需要stopInner
            // 1. 如果播放列表中还有下一个视频等待播放
            // 2. 如果是灵活的列表播放场景（isPlayList=true），播放器可能还会继续被append视频播放，因此不能被停止，而是等待用户添加视频
            this.stopInner(END_STATE.NORMAL, true, videoInfo);
            // 在停止当前播放以后，发出当前段播放结束事件
            this.emit(PLAY_EVENT.VIDEONODE_PLAY_OVER, { videoInfo: videoInfo });
        }
        else {
            // 在播放下一段之前，发出当前段播放结束
            this.emit(PLAY_EVENT.VIDEONODE_PLAY_OVER, { videoInfo: this.currentVideoInfo });
            this.checkPlayNext();
        }
        return false;
    };
    /** 处理videoNode播放错误 */
    BasePlayer.prototype.onVideoNodeError = function (e) {
        var videoInfo = (e.data || {}).videoInfo;
        // this.detectSourceOnError(videoInfo);
        this.stopInner(END_STATE.ERROR, true, videoInfo);
        // stopInner第二个参数为true，直接发出error和stop事件了，不需要派发事件
        return false;
    };
    /** 打印VideoNode事件关键信息，但排除开一些高频事件的打印 */
    BasePlayer.prototype.logVideoNodeEvts = function (e) {
        var _a, _b;
        // 过滤掉频繁产生的 VideoNode 事件
        if (IGNORE_EVT_TYPE.includes(e.type)) {
            return;
        }
        // 过滤掉频繁产生的 IVideoElement 事件
        if (e.type === VIDEO_NODE_EVENT.ELEMENT_EVTS && IGNORE_VIDEO_EVT.includes(e.data.elementEvtType)) {
            return;
        }
        var logData = e.data;
        if (e.type === VIDEO_NODE_EVENT.STATE_CHANGE) {
            logData = "[".concat(e.data.old, "->").concat(e.data.new, "]");
        }
        else if (e.type === VIDEO_NODE_EVENT.ELEMENT_EVTS) {
            logData = "[elementEvtType=".concat(e.data.elementEvtType, "]");
        }
        this._logger.log("get VideoNode evt, type=".concat(e.type, "/uid=").concat((_b = (_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) === null || _b === void 0 ? void 0 : _b.uid, "/data="), logData);
    };
    BasePlayer.prototype.playBlocked = function () {
        var _this = this;
        this._playBlocking = true;
        this._triggerAutoplayPromise = null;
        setTimeout(function () {
            // setTimeout避免在block事件的监听回调里面调用play的时候还没有调用load而播放器状态为state
            // (修复autoblock事件太晚导致静音自动播不生效问题)
            _this.emit(PLAY_EVENT.AUTOPLAY_BLOCKED, { videoInfo: _this.currentVideoInfo });
        }, 0);
        this.setLoading(false);
    };
    BasePlayer.prototype.checkPlayNext = function () {
        var playNextDetail = this.playerStatusChecker.checkCanPlayNext();
        this._logger.log(playNextDetail.message);
        if (playNextDetail.canPlayNext) {
            this.playNextInner();
        }
    };
    /**
    * 检查是否需要自动预加载下一个视频
    * @param leftTime 离视频播放的结束时间
    */
    BasePlayer.prototype.checkAutoPreloadNext = function (leftTime) {
        var preloadDetail = this.playerStatusChecker.checkAutoPreloadNext(leftTime);
        if (preloadDetail.canPreload) {
            this.preloadInner(false, { startTime: 0, kernelName: this.kernelName }, this.nextVideoInfo);
        }
    };
    /** 修改当前_curVideoNode指向 */
    BasePlayer.prototype.setCurVideoNode = function (vn, isForceSet) {
        if (isForceSet === void 0) { isForceSet = false; }
        if (this._curVideoNode === vn && !isForceSet) {
            return;
        }
        if (this._curVideoNode) {
            this._curVideoNode.onAccurateTimeupdate = null;
            this.setPlayEvents(this._curVideoNode, false);
        }
        if (vn) {
            this._curVideoNode = vn;
            this._curVideoNode.onAccurateTimeupdate = this.checkAccuratePlaytime.bind(this);
            this.setPlayEvents(this._curVideoNode, true);
        }
    };
    /** 在播放错误时，使用range请求获取当前播放的视频的一段数据用于探测远程资源 */
    BasePlayer.prototype.detectSourceOnError = function (videoInfo) {
        var _this = this;
        var _a = videoInfo || {}, loadingUrl = _a.loadingUrl, uid = _a.uid;
        if (!loadingUrl) {
            this._logger.error('detectSourceOnError, url=null');
            return;
        }
        detectStream(loadingUrl)
            .then(function (data) {
            _this._logger.error("detectSourceOnError=".concat(jsonTool.safelyStringify(__assign({ uid: uid }, data))));
        })
            .catch(function (e) {
            _this._logger.error('detectSourceOnError err', e === null || e === void 0 ? void 0 : e.message);
        });
    };
    /** 在播放器层的loading动画展示时机逻辑 */
    BasePlayer.prototype.setLoading = function (show) {
        this.emit(PLAY_EVENT.SET_LOADING, { show: show });
    };
    /** 在页面不可见时，出现状态切换，申请常亮可能被系统拒绝。因此在页面恢复可见时，重新设置屏幕常亮 */
    BasePlayer.prototype.visibilityChangeHandler = function () {
        this.screenWakeLock.keepAlive(this.state === VIDEO_STATE.PLAYING);
    };
    /** 对播放列表Play方法的不同情况处理 */
    BasePlayer.prototype.triggerPlayResolve = function (urlConfig, extra) {
        var _this = this;
        if (urlConfig) {
            // 只要有urlConfig参数，需要重新开始播放
            if (this.loadInner(urlConfig, extra)) {
                this.setLoading(true);
                this.triggerPlayAfterLoad();
            }
            return;
        }
        // 没有urlConfig参数，需要按以下几个情况分别处理
        if (!this._played) {
            // 情况一：外部调用load后，再调用play(或点击play按钮)，需要显示下loading（可能是调用了load接口，但还没有预加载完）
            this.setLoading(true);
            this.triggerPlayAfterLoad();
            return;
        }
        if (this._playBlocking || videoTool.cannotDetectAutoPlayBlock()) {
            // 情况二：看看是否被自动播放阻止（或者根本就无法检测到自动播放被拦截），直接恢复播放即可
            this._playBlocking = false;
            // safari播放被阻止后，再次调用play接口会先走triggerAuthplay，再走到resumeInner，但是马上调用无效（原因未知），
            // setTimeout可解决。其他浏览器没有这个问题，因此这里干脆延迟一个循环再执行。
            setTimeout(function () {
                var _a, _b;
                if (((_b = (_a = _this._curVideoNode) === null || _a === void 0 ? void 0 : _a.videoBuffered) === null || _b === void 0 ? void 0 : _b.length) <= 0) {
                    // 可能是某些浏览器被自动播放阻止后，根本没有加载数据和派发loadStart事件（调用video.load()接口），点击恢复
                    // 播放需要继续加载数据才能看到画面，此时为黑屏状态，因此当没有buffer数据时，需要展示加载loading
                    _this.setLoading(true);
                }
                _this.resumeInner();
            }, 0);
            return;
        }
        if ([VIDEO_STATE.PAUSE, VIDEO_STATE.CANPLAY, VIDEO_STATE.SEEKED].indexOf(this.state) !== -1) {
            // 情况三：（兜底逻辑）视频在以下状态【暂停、可以开播、seeked】，恢复播放即可
            this.resumeInner();
            return;
        }
        // 三种情况都不匹配，play接口做不了任何事情，已经兜底不会出现这种情况，打印日志以定位后续某情况走到该分支
        this._logger.log('play() has been called, but cannot do nothing.');
    };
    /** 如果预加载过第一个视频，那么等待预加载成功后开始播放 */
    BasePlayer.prototype.triggerPlayAfterLoad = function () {
        if (this._played || this._curUrlIdx !== -1) {
            return;
        }
        var firstVideoInfo = this._videoInfos[0];
        if (firstVideoInfo) {
            this._played = true;
            this._curUrlIdx = 0;
            this.playInner();
        }
    };
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "play", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "seek", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "stop", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array, Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "appendNext", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "preloadNext", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playNext", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "resizeVideoElements", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "resumeInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object, Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "stopInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Object, Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "preloadInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playNextInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playBlocked", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "checkPlayNext", null);
    return BasePlayer;
}(EvtEmitter));
export default BasePlayer;
